import { createFileRoute } from '@tanstack/react-router';
import { DeliveryPage } from '@/features/delivery/delivery-page.js';

export const Route = createFileRoute('/_app/deliver')({
  component: DeliveryPage,
});
